<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

defineProps<{ class?: HTMLAttributes["class"] }>();
</script>

<template>
  <div :class="cn('grid gap-1.5 text-left', $props.class)">
    <slot />
  </div>
</template>
